import { useScreenSize } from '@hooks';
import { Button, Flex, theme, Typography } from '@styles';
import { func, string } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '../Icon';
import { Line } from '../Line';
import { actionButtonLayoutByVariant } from './ActivityModalLayout.layoutProps';

const ActivityModalLayout = ({ onModalClose, variant }) => {
  const { i18n } = useTranslation();
  const { isTabletSM } = useScreenSize();

  const contentLayout = actionButtonLayoutByVariant[variant];

  return (
    <Flex
      flexDirection="column"
      p={isTabletSM ? 20 : 40}
      width="100%"
      {...(isTabletSM && { justifyContent: 'space-between' })}
    >
      <Flex flexDirection="column">
        <Flex alignItems="center" mb={4}>
          <Icon height={56} mr={4} SVG={contentLayout.svg} width={56} />
          <Typography
            color={theme.colors.white[100]}
            variant={isTabletSM ? 'MS-bold-s18-lh22' : 'MS-bold-s28-lh29'}
          >
            {i18n.t(contentLayout.titleText).toUpperCase()}
          </Typography>
        </Flex>
        <Typography
          color={theme.colors.white[100]}
          mb={4}
          variant={isTabletSM ? 'MS-regular-s16-lh25' : 'MS-regular-s22-lh34'}
        >
          {i18n.t(contentLayout.content)}
        </Typography>
      </Flex>
      <Flex flexDirection="column">
        <Line mb={4} />
        <Button onClick={onModalClose} py={21} variant="secondary" width="100%">
          <Typography variant="MS-semibold-s16-lh25">
            {i18n.t('ActivityModal.Close').toUpperCase()}
          </Typography>
        </Button>
      </Flex>
    </Flex>
  );
};

ActivityModalLayout.propTypes = {
  onModalClose: func.isRequired,
  variant: string.isRequired,
};

export default ActivityModalLayout;
